var _a;
import createStore from 'zustand';
import { createHydrationSlice, } from '@core/hydration/model';
const createGlobalStore = () => {
    return createStore((set) => (Object.assign({}, createHydrationSlice(set))));
};
let useGlobalStore = typeof window !== 'undefined' && ((_a = window === null || window === void 0 ? void 0 : window._fwn) === null || _a === void 0 ? void 0 : _a.useGlobalStore);
export const getGlobalStore = () => {
    if (!useGlobalStore) {
        useGlobalStore = createGlobalStore();
        if (typeof window !== undefined && window._fwn) {
            window._fwn.useGlobalStore = useGlobalStore;
        }
    }
    return useGlobalStore;
};
export const TEST_ONLY = {
    resetStore: () => {
        useGlobalStore = undefined;
        if (typeof window !== undefined && window._fwn) {
            window._fwn.useGlobalStore = undefined;
        }
    },
};
